
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  PAGE_VIEW
  /*
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  REMOVE_EVENT_FROM_BETSLIP,
  */
} from 'Store/constants';
  
import {
  setContactKey,
  setPageView
} from 'Utils/dengageEvents';

export const dengageAppEventsCollector = () => {
  return next => action => {
    const returnValue = next(action);

    if (action.type === LOGIN_SUCCESS ) {
      const userID =  action.payload?.externalCustomerId || 'null';
      setContactKey(userID);
    }

    if (action.type === LOGOUT_SUCCESS) {
      setContactKey('');
    }

    if (action.type === PAGE_VIEW ) {
      const pageURL =  action.payload.url;
      if (pageURL === '/') {
        setPageView('Anasayfa');
      } else if (pageURL === '/tribun') {
        setPageView('Tribun');
      } else if (pageURL.includes('/canli-mac-izle')) {
        setPageView('Canlı Yayınlar');
      } else if (pageURL.includes('/iddaa')) {
        setPageView('Bülten');
      }
    }


    return returnValue;
  };
};